import SponsorshipList from "./SponsorshipList";

export default SponsorshipList